function imagePreviewState() {
  return {
    initialLeft: "",
    initialTop: "",
    height: { feet: "", inches: "" },
    width: [{ feet: "", inches: "" }],
    get show() {
      const url = new URL(window.location.href);
      const isPreviewImage = url.searchParams.get('view') === 'cropped-image-preview';
      return isPreviewImage;
    },
    init() {
      const url = new URL(window.location.href);
      this.initialLeft = url.searchParams.get('initialLeft') ?? "";
      this.initialTop = url.searchParams.get('initialTop') ?? "";
      this.flipped = url.searchParams.get('flipped') === 'true';
      let height = url.searchParams.get('height') ?? "";
      let width = url.searchParams.get('width') ?? "";
      this.height = this.convertCmToFeetAndInches(height);
      this.width = [this.convertCmToFeetAndInches(width)];
      const cropboxData = url.searchParams.get("cropbox-data");

this.cropboxData = {};

if (cropboxData) {
  try {
    this.cropboxData = JSON.parse(decodeURIComponent(cropboxData));

    if (typeof this.cropboxData.flipped === 'boolean') {
      this.flipped = this.cropboxData.flipped;
    }
  } catch (error) {
    console.error("Invalid cropbox-data:", error);
  }
}
    },
    convertCmToFeetAndInches(cm = 0) {
      const totalInches = cm / 2.54;
      const feet = Math.floor(totalInches / 12);
      const inches = Math.round(totalInches % 12);

      return {
        feet: feet,
        inches: inches
      };
    },
    downloadImage() {
      const img = document.querySelector('.main-image');
      const overlay = document.querySelector('.selection-overlay');

      if (!img || !overlay) return;

      // Get natural dimensions of the image
      const imgRect = img.getBoundingClientRect();
      const overlayRect = overlay.getBoundingClientRect();
      const scaleX = img.naturalWidth / imgRect.width;
      const scaleY = img.naturalHeight / imgRect.height;

      // Calculate the overlay's position and size in the context of the natural image dimensions
      const cropX = (overlayRect.left - imgRect.left) * scaleX;
      const cropY = (overlayRect.top - imgRect.top) * scaleY;
      const cropWidth = overlayRect.width * scaleX;
      const cropHeight = overlayRect.height * scaleY;

      // Create a canvas to draw the cropped overlay area
      const canvas = document.createElement('canvas');
      canvas.width = cropWidth;
      canvas.height = cropHeight;
      const ctx = canvas.getContext('2d');

      // If flipped, mirror the image horizontally on the canvas
      if (this.flipped) {
        ctx.translate(cropWidth, 0);
        ctx.scale(-1, 1);
        // Adjust cropX to capture the flipped position on the original image
        ctx.drawImage(
          img,
          img.naturalWidth - cropX - cropWidth,
          cropY,
          cropWidth,
          cropHeight,
          0,
          0,
          cropWidth,
          cropHeight
        );
      } else {
        // Draw only the overlay area from the main image onto the canvas
        ctx.drawImage(
          img,
          cropX,
          cropY,
          cropWidth,
          cropHeight,
          0,
          0,
          cropWidth,
          cropHeight
        );
      }

      // Trigger download
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = 'cropped_overlay.png';
      link.click();
    }
  };
}
